/** Display for zero numeric values in rewards tables (admin summary). */
export const REWARDS_ZERO_DISPLAY = '-';

export function parseRewardsAmount(amount: number | string): number {
  const value = typeof amount === 'string' ? parseFloat(amount) : amount;
  return Number.isFinite(value) ? value : 0;
}

export interface FormatRewardsUsdOptions {
  /** When set, returned instead of a currency string for numeric zero. */
  zeroDisplay?: string | null;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

/**
 * USD formatting with en-US grouping (e.g. $1,234.56).
 */
export function formatRewardsUsd(
  amount: number | string,
  options: FormatRewardsUsdOptions = {}
): string {
  const n = parseRewardsAmount(amount);
  if (options.zeroDisplay != null && n === 0) {
    return options.zeroDisplay;
  }

  const minimumFractionDigits = options.minimumFractionDigits ?? 2;
  const maximumFractionDigits = options.maximumFractionDigits ?? 2;

  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
    maximumFractionDigits,
  });
}

/**
 * Rule cards and earning criteria: whole dollars omit cents (e.g. $12, $1,234).
 */
export function formatRewardsRuleAmount(amount: number | string): string {
  const n = parseRewardsAmount(amount);
  const isInteger = Number.isInteger(n);
  return formatRewardsUsd(n, {
    minimumFractionDigits: isInteger ? 0 : 2,
    maximumFractionDigits: isInteger ? 0 : 2,
  });
}
